import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_EXTERNAL_USER_GROUP_LIST_WITH_ASSOCIATION = "GET_EXTERNAL_USER_GROUP_LIST_WITH_ASSOCIATION";

export const service = async (data) => {
  const options: object = {
    url: `/Api/ExternalUser/GetExternalUserGroupListWithAssociation`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_EXTERNAL_USER_GROUP_LIST_WITH_ASSOCIATION, service, mock);
